import { useEffect, useState } from "react";
import { trackWhatsAppClick } from "../trackWhatsApp";

const MAX_SCROLL = 200;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const value = Math.min(window.scrollY / MAX_SCROLL, 1);
          setOpacity(value);
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    setIsMenuOpen(false);
    const section = document.getElementById("inicio");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-colors duration-300"
      style={{
        backgroundColor: `rgba(50, 61, 38, ${0.95 * opacity})`,
        backdropFilter: opacity > 0.2 ? "blur(12px)" : "none",
        boxShadow: opacity > 0.3 ? "0 10px 30px rgba(0, 0, 0, 0.35)" : "none",
      }}
    >
      <div
        className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-wood-400 to-transparent transition-opacity duration-300"
        style={{ opacity }}
      />
      <div className="max-w-6xl mx-auto px-2 md:px-3">
        <div className="flex items-center justify-between py-4">
          <button
            onClick={scrollToTop}
            aria-label="Voltar para o início"
            className="flex flex-col items-center leading-none cursor-pointer select-none hover:opacity-90 transition-opacity"
          >
            <img
              src="/images/logo-simple.webp"
              alt="Marcos Jones Marcenaria"
              width="72"
              height="56"
              className="h-14 md:h-16 lg:h-18 object-contain"
            />
            <span className="text-xs md:text-sm text-wood-300 tracking-widest font-semibold mt-1">
              MARCENARIA
            </span>
          </button>
          <nav
            className={`
              absolute md:relative top-full md:top-0 left-0 right-0
              bg-military-700 md:bg-transparent
              backdrop-blur-xl md:backdrop-blur-none
              transition-all duration-300
              ${
                isMenuOpen
                  ? "max-h-96 opacity-100"
                  : "max-h-0 opacity-0 md:max-h-none md:opacity-100"
              }
            `}
          >
            <ul className="flex flex-col md:flex-row items-center gap-6 md:gap-8 py-6 md:py-0 ">
              {[
                { href: "#servicos", label: "Serviços" },
                { href: "#about", label: "Sobre nós" },
                { href: "#feedback", label: "Avaliações" },
                { href: "#contato", label: "Contato" },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setIsMenuOpen(false)}
                    className="
                      relative group
                      text-wood-400 hover:text-wood-300
                      font-semibold  transition-colors duration-300
                      px-2 py-1
                    "
                  >
                    {item.label}
                    <span
                      className="
                        absolute left-0 -bottom-1
                        w-0 h-[2px]
                        bg-military-500
                        transition-all duration-300
                        group-hover:w-full
                      "
                    />
                    <span
                      className="
                        absolute -left-2 top-1/2 -translate-y-1/2
                        w-[2px] h-0
                        bg-military-500
                        transition-all duration-300
                        group-hover:h-6
                      "
                    />
                  </a>
                </li>
              ))}
            </ul>
          </nav>
          <a
            href="https://wa.me/5511974957987?text=Olá!%20Gostaria%20de%20um%20orçamento%20de%20móvel%20sob%20medida."
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackWhatsAppClick("header")}
            className="
              hidden md:block
              bg-gradient-to-r bg-wood-500 to-wood-400
              text-military-700 font-bold
              px-8 py-4 rounded-2xl
              shadow-lg hover:shadow-xl
              transform hover:-translate-y-1
              transition-all duration-300
              relative overflow-hidden group
            "
          >
            <span className="relative z-10 text-wood-300">
              Solicitar Orçamento
            </span>
            <div className="absolute inset-0 w-0 bg-wood-500/10 transition-all duration-300 group-hover:w-full" />
          </a>
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 space-y-1.5"
            aria-label="Abrir menu"
          >
            <span
              className={`w-6 h-0.5 bg-military-400 transition-all duration-300 ${
                isMenuOpen ? "rotate-45 translate-y-2" : ""
              }`}
            />
            <span
              className={`w-6 h-0.5 bg-military-400 transition-all duration-300 ${
                isMenuOpen ? "opacity-0" : ""
              }`}
            />
            <span
              className={`w-6 h-0.5 bg-military-400 transition-all duration-300 ${
                isMenuOpen ? "-rotate-45 -translate-y-2" : ""
              }`}
            />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
